import type { ThemeWithoutTokens } from '../theme.types';

export const chipTokens = (theme: ThemeWithoutTokens) =>
  ({
    // Chip Size
    chipHeightSmall: theme.typography.lineHeight.xs,
    chipHeightMedium: theme.typography.lineHeight.s,
    chipHeightLarge: theme.typography.lineHeight.m,

    // Chip Padding
    chipPaddingSmall: theme.space.component.x.xs,
    chipPaddingMedium: theme.space.component.x.s,
    chipPaddingLarge: theme.space.component.x.s,

    // Chip Background
    chipBlueBackgroundColor: theme.palette.blue400Alpha,
    chipBlueOutlineBackgroundColor: theme.palette.blue50,
    chipGreenBackgroundColor: theme.palette.green400alpha,
    chipGreenOutlineBackgroundColor: theme.palette.green50,
    chipGreyBackgroundColor: theme.palette.grey200,
    chipGreyOutlineBackgroundColor: theme.palette.grey100,
    chipOrangeBackgroundColor: theme.palette.orange400alpha,
    chipOrangeOutlineBackgroundColor: theme.palette.orange50,
    chipPurpleBackgroundColor: theme.palette.purple400alpha,
    chipPurpleOutlineBackgroundColor: theme.palette.purple400alpha,
    chipRedBackgroundColor: theme.palette.red400alpha,
    chipRedOutlineBackgroundColor: theme.palette.red400alpha,
    chipYellowBackgroundColor: theme.palette.yellow400alpha,
    chipYellowOutlineBackgroundColor: theme.palette.yellow50,
    chipRemovableBackgroundColor: theme.palette.grey100,
    chipDisabledBackgroundColor: theme.palette.grey200,

    // Chip Text Color
    chipDefaultTextColor: theme.colors.body.text,
    chipDefaultOutlineTextColor: theme.palette.black,
    chipGreenTextColor: theme.colors.success.textDark,
    chipGreyTextColor: theme.palette.grey700,
    chipOrangeTextColor: theme.colors.warning.textDark,
    chipPurpleTextColor: theme.palette.purple700,
    chipRedTextColor: theme.colors.danger.textDark,
    chipYellowTextColor: theme.palette.yellow700,
    chipDisabledTextColor: theme.colors.disabled.text,

    // Chip Font
    chipFontSize: theme.typography.fontSize.xs,
    chipFontFamily: theme.typography.fontFamily.regular,
    chipFontLineHeight: theme.typography.lineHeight.xs,
    chipFontWeight: theme.typography.fontWeight.semibold,

    // Chip Border Color
    chipBlueOutlineBorderColor: theme.palette.blue300,
    chipGreenOutlineBorderColor: theme.palette.green300,
    chipGreyOutlineBorderColor: theme.palette.grey200,
    chipOrangeOutlineBorderColor: theme.palette.orange300,
    chipPurpleOutlineBorderColor: theme.palette.purple200,
    chipRedOutlineBorderColor: theme.palette.red300,
    chipYellowOutlineBorderColor: theme.palette.yellow300,

    // radiuses
    chipRadius: theme.radiuses.xxl,
  }) as const;
